import React, { useState } from 'react'
import { useEffect } from 'react'
import { getPaymentScheduleSummary } from '../../../store/slices/groupFiles/thunks'
import { useDispatch } from 'react-redux'
import { PaymentSchemeSummaryDetails } from './PaymentSchemeSummaryDetails'

export const PaymentSchemeSummary = ({ groupFile }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPaymentScheduleSummary(groupFile.id));
  }, [])

  return (
    <div style={{ marginTop: 20 }}>
      <div style={{ fontSize: 20 }}>Resumen del plan de pagos</div>

      <PaymentSchemeSummaryDetails groupFile={groupFile} />
    </div>
  )
}
